const actions = {
  CLEAR_MESSAGE: 'CLEAR_MESSAGE',

  CREATE_NOTE: 'CREATE_NOTE',
  CREATE_NOTE_LOADING: 'CREATE_NOTE_LOADING',
  CREATE_NOTE_SUCCESS: 'CREATE_NOTE_SUCCESS',
  CREATE_NOTE_FAILED: 'CREATE_NOTE_FAILED',

  FETCH_NOTES: 'FETCH_NOTES',
  FETCHING_NOTES: 'FETCHING_NOTES',
  FETCH_NOTES_SUCCESS: 'FETCH_NOTES_SUCCESS',
  FETCH_NOTES_FAILED: 'FETCH_NOTES_FAILED',

  UPDATE_NOTE: 'UPDATE_NOTE',
  UPDATE_NOTE_LOADING: 'UPDATE_NOTE_LOADING',
  UPDATE_NOTE_SUCCESS: 'UPDATE_NOTE_SUCCESS',
  UPDATE_NOTE_FAILED: 'UPDATE_NOTE_FAILED',

  PIN_NOTE: 'PIN_NOTE',
  PIN_NOTE_LOADING: 'PIN_NOTE_LOADING',
  PIN_NOTE_SUCCESS: 'PIN_NOTE_SUCCESS',
  PIN_NOTE_FAILED: 'PIN_NOTE_FAILED',

  clearMessage: () => ({
    type: actions.CLEAR_MESSAGE
  }),

  createNote: payload => ({
    type: actions.CREATE_NOTE,
    payload
  }),

  fetchNotes: payload => ({
    type: actions.FETCH_NOTES,
    payload
  }),

  updateNote: payload => ({
    type: actions.UPDATE_NOTE,
    payload
  }),

  pinNote: payload => ({
    type: actions.PIN_NOTE,
    payload
  })
};
export default actions;
